import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useProjects } from '../../../../hooks/useProjects';

import { UnauthorizedLoadingPage } from '../../../../pages/UnauthorizedLoadingPage';
import { useAuth } from '../../../../hooks/useAuth';
import useSessionStorageProject from './useSessionStorageProject';
import useVerifyUserAccess from '../../../../contexts/Forge/hooks/useVerifyUserAccess';
import cookies from 'browser-cookies';

export default function SetProjectSourceIdFromRoute() {
	const { projectSourceId } = useParams<{ projectSourceId: string }>();
	const history = useHistory();
	const {
		injectProjectBySourceId,
		projects,
		initializeProjects,
		isFetching,
		isInitialized,
	} = useProjects();
	const { redirectToAutodesk, hasValidToken } = useAuth();
	const { handleFailedInitialization } = useVerifyUserAccess();

	const { setSource: setProject } = useSessionStorageProject();

	const handleProjectInjectionAuthentication = React.useCallback(
		(sourceId: string) => {
			if (!hasValidToken()) {
				localStorage.setItem('forge.auth.sourceId', sourceId);
				redirectToAutodesk();
			}
		},
		[hasValidToken, redirectToAutodesk],
	);

	React.useEffect(() => {
		handleProjectInjectionAuthentication(projectSourceId);
	}, []);

	React.useEffect(() => {
		// If we arrive at this page without a code, route to root
		if (!projectSourceId) {
			console.log('could not pull projectSourceId from route');
			history.replace('/');
		} else {
			// Initialize projects if not loaded
			if (!isInitialized) {
				initializeProjects();
			}
			// If we have no projects for a user after fetch
			else if (!isFetching && projects?.length === 0) {
				handleFailedInitialization();
			}
			// Happy path - we have projects loaded
			else if (!isFetching && projects?.length > 0) {
				// Workaround for feature toggles not being loaded
				// TODO: Remove this once product picker toggle is removed
				localStorage.setItem('projectFlow', 'true');
				setProject(projectSourceId);
				injectProjectBySourceId(projectSourceId);
				setTimeout(() => {
					history.replace('/');
				}, 300);
			}
		}
	}, [projectSourceId, projects?.length, isInitialized, isFetching]);
	return <UnauthorizedLoadingPage />;
}
